// routes for Equipment
import { AppRouteProps } from '~/routes';
import Index from './pages/Index';
import Create from './pages/Create';
import Edit from './pages/Edit';

export default function ResourcesEquipmentsRoutes(): readonly AppRouteProps[] {
  const routes: readonly AppRouteProps[] = [
    {
      path: '/equipment',
      component: Index,
      isProtected: true,
      permissions: ['equipment_index'],
    },
    {
      path: '/equipment/create',
      component: Create,
      isProtected: true,
      permissions: ['equipment_create'],
    },
    {
      path: '/equipment/edit/:id',
      component: Edit,
      isProtected: true,
      permissions: ['equipment_edit'],
    },
  ];

  return routes;
}
